import {
  CREATEUSERPOOLCLIENT_SUCCESS,
  UPDATEUSERPOOLCLIENT_SUCCESS,
  FETCHUSERPOOLCLIENTS_SUCCESS,
  DELETEUSERPOOLCLIENT_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  userPoolClients: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCHUSERPOOLCLIENTS_SUCCESS: {
      return {
        ...state,
        userPoolClients: action.payload.listUserPoolClients
      }
    }

    case CREATEUSERPOOLCLIENT_SUCCESS: {
      return {
        ...state,
        createdUserPoolClient: action.payload.createUserPoolClient
      }
    }

    case UPDATEUSERPOOLCLIENT_SUCCESS: {
      return {
        ...state,
        updatedUserPoolClient: action.payload.updateUserPoolClient
      }
    }

    case DELETEUSERPOOLCLIENT_SUCCESS: {

      return {
        ...state,
        deleted: action.payload,
      }
    }

    default:
      return {
        ...state,
        createdUserPoolClient: false,
        updatedUserPoolClient: false,
        deleted: false
      }
  }
}
